import { TableV2Column } from 'components/Table/TableV2';
import { CampaignJobTitleCell } from 'pages/Campaigns/components/CampaignJobTitleCell';
import { Campaign } from 'services/campaign/types';
import { formatDate } from 'utils/datetime';
import { SearchCampaignItem } from '../types/SearchCampaigns';
import { SearchableCampaignSortableFields } from 'generated-graphql/types';

export const getSelectCampaignsColumns = ({
  addChildrenCampaignsToParentGroupCampaign,
  removeChildrenCampaignsFromParentGroupCampaign,
  onJobTitleClick
}: {
  addChildrenCampaignsToParentGroupCampaign: ({
    childrenCampaigns,
    campaignGroupId,
    isParentInOtherCampaigns
  }: {
    childrenCampaigns: Campaign[];
    campaignGroupId: string;
    isParentInOtherCampaigns: boolean | undefined;
  }) => void;
  removeChildrenCampaignsFromParentGroupCampaign: ({
    campaignGroupId,
    childrenCampaigns
  }: {
    campaignGroupId: string;
    childrenCampaigns: Campaign[];
  }) => void;
  onJobTitleClick: (campaign: Campaign | SearchCampaignItem) => void;
}) => {
  const columns: TableV2Column<SearchCampaignItem>[] = [
    {
      name: 'Job title',
      minWidth: '300px',
      cell: (row) => {
        return (
          <CampaignJobTitleCell
            campaign={row}
            onClick={onJobTitleClick}
            addChildrenCampaignsToParentGroupCampaign={
              addChildrenCampaignsToParentGroupCampaign
            }
            removeChildrenCampaignsFromParentGroupCampaign={
              removeChildrenCampaignsFromParentGroupCampaign
            }
          />
        );
      },
      id: SearchableCampaignSortableFields.Title,
      sortable: true,
      sortField: SearchableCampaignSortableFields.Title
    },
    {
      name: 'Location',
      selector: (row) => row?.jobDescriptionParsed?.location || '-'
    },
    {
      name: 'Last activity',
      selector: (row) => (row?.updatedAt ? formatDate(row.updatedAt) : '-'),
      isAction: true,
      sortable: true,
      sortField: SearchableCampaignSortableFields.UpdatedAt,
      id: SearchableCampaignSortableFields.UpdatedAt
    }
  ];

  return columns;
};
